import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSessionJWT, useSessionCtx } from "utils";
import { deletePaymentMethod } from "./index.js";

export default function useDeletePaymentMethod() {
  const queryClient = useQueryClient();
  const { sessionJWT } = useSessionJWT();
  const { sessionId } = useSessionCtx();
  const ctx = {
    ...sessionJWT,
    sessionId,
  };

  return useMutation({
    mutationFn: ({ id }) => deletePaymentMethod(ctx, id),
    onSuccess: () => {
      // since a payment method is updated, fetching payment method should not be from cache
      queryClient.invalidateQueries({ queryKey: ["transaction-methods"] });
    },
  });
}
